/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Protocol_RefreshInputs */

const cs_tasks_protocol_refresh = /** @type {(inputs: Tasks_Protocol_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit stav`)
};

const en_tasks_protocol_refresh = /** @type {(inputs: Tasks_Protocol_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh status`)
};

/**
* | output |
* | --- |
* | "Refresh status" |
*
* @param {Tasks_Protocol_RefreshInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const tasks_protocol_refresh = /** @type {((inputs?: Tasks_Protocol_RefreshInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Protocol_RefreshInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_protocol_refresh(inputs)
	return cs_tasks_protocol_refresh(inputs)
});